import { Injectable } from '@angular/core'

import { ClubAdapter } from '../../shared/adapters/ClubAdapter'
import { XHRService } from '../../shared/services/xhr.service'
import {
  ClubConfigResponse,
  ServicesConfiguration,
} from './servicing-club.types'

@Injectable({
  providedIn: 'root',
})
export class ServicingClubService {
  constructor(
    private xhr: XHRService,
    private clubAdapter: ClubAdapter
  ) {}

  async getServicingClubConfigs(club: string): Promise<ServicesConfiguration> {
    try {
      const response = await this.xhr.authRequest<ClubConfigResponse>(
        {
          url: `bff/club/${club}/config`,
          method: 'GET',
        }
      )
      return this.clubAdapter.adaptClubConfig(response)
    } catch (error) {
      throw error
    }
  }
}
